const guidance = {
  caseGtin: 'To select an existing hierarchy, please click the Hierarchy button. If this is a new hierarchy not already in our platform, please input the case GTIN for this case configuration. If there is no case code for this new hierarchy, please place a checkmark in the No Case Code box.',
  caseUpc12: 'Enter the barcode on the case packaging, or select No Case Code when no case barcode exists.',
  unitUpc: 'Enter the retail-scannable barcode printed on the individual unit. Check the digits and check digit.',
  innerPackGtin: 'Enter the innerpack GTIN. It must differ from the Unit and Case GTINs.',
  innerPackUpc: 'Enter the innerpack retail barcode when it is sellable. It must differ from the unit barcode.',
  hierarchyId: 'Click Hierarchy and select the packaging configuration you are sending for recapture.',
  brandId: 'Click Select Brand and choose an existing brand or create a new brand.',
  brandName: 'Click Select Brand and choose an existing brand or create a new brand.',
  productName: 'Enter a product name of up to 70 characters.',
  productDescription: 'Enter a product description of up to 250 characters.',
  size: 'Enter the product size shown on its packaging.',
  sizeUom: 'Choose the unit of measure corresponding to the product size.',
};

export const getWizardValidationGuidance = (field) =>
  guidance[field] || 'Correct the indicated field in the grid, then click Submit to validate the updated data.';
